export default {
  notMe: 'Não é {name}?',
  login: 'Entrar',
  actual: 'Português'
}
